import { MemoTable } from "../../../components/MemoTable";
import { PeriodSelector } from "../../../components/PeriodSelector";
import { MetricsType } from "../../../metrics.types";
import {
    incomeStatementResolutionAtom,
    incomeStatementMetricsAtom,
} from "../../../metrics.state";
import { useCallback } from "react";
import { useSetAtom, useAtomValue } from "jotai";
import { AIMContextViewAtom } from "../../../state/context.state";
import { AIMViewType } from "../../../InvestmentMemo.types";
import { ISSummaryColumnAtom, ISSummaryDataAtom } from "./ISSummary.state";
import { CellClickedEvent } from "ag-grid-enterprise";
import { SummaryRow } from "../SummaryFinancials.types";
import { defaultColDef } from "../defaultColDef";

export function IncomeStatementSummary() {
    const metrics = useAtomValue(incomeStatementMetricsAtom);
    const resolution = useAtomValue(incomeStatementResolutionAtom);
    const data = useAtomValue(ISSummaryDataAtom);
    const columns = useAtomValue(ISSummaryColumnAtom);
    console.log("IS Summary", metrics, data, resolution, columns);
    const setAIMContextView = useSetAtom(AIMContextViewAtom);
    const handleClick = useCallback(
        (params: CellClickedEvent<SummaryRow>) => {
            const field = params.colDef.field;
            if (field === "label" || !params.data?.metric || !field) return;

            if (field === "popChange" && params.data.popChange) {
                setAIMContextView({
                    type: AIMViewType.DELTA_LINEAGE,
                    props: {
                        metric: params.data.metric,
                        metricLabel: params.data.label,
                        currentSlice: params.data.currentSlice,
                        previousSlice: params.data.previousSlice,
                        popChange: params.data.popChange,
                        fieldType: params.data.fieldType,
                        resolutionWindow: resolution.window || "",
                        popLabel: params.colDef.headerName,
                    },
                });
                return;
            } else {
                setAIMContextView({
                    type: AIMViewType.VALUE_LINEAGE,
                    metric: params.data.metric,
                    period: field,
                    title: params.data.label,
                });
            }
        },
        [metrics, resolution, setAIMContextView],
    );

    return (
        <div id="summary-income-statement" className="space-y-3">
            <div className="flex items-center justify-between">
                <h4 className="heading-m">Summary Income Statement</h4>
                <PeriodSelector
                    resolutionAtom={incomeStatementResolutionAtom}
                    metricsType={MetricsType.INCOME_STATEMENT}
                />
            </div>
            <MemoTable
                data={data}
                columns={columns}
                onCellClicked={handleClick}
                defaultColDef={defaultColDef}
            />
        </div>
    );
}
